module.exports = __webpack_public_path__ + "img/blomkaal.61481701.jpg";